export function Card({ children, className = '', onClick }) {
  return (
    <div 
      className={`bg-white shadow-sm ${className}`} 
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      {children}
    </div>
  );
} 